import { DateTime } from 'luxon';

export function showPromo(config) {
	if (!config) return false;

	let id = config.id,
		showCount = config.showCount,
		bufferMinutes = config.bufferMinutes;

	if (!id) return false;

	if (config.cookieCheck) {
		let re = new RegExp(config.cookieCheck),
			cookieMatch = document.cookie.match(re);
		if (!cookieMatch) return false;
	}

	let lsPromoCount = parseInt(localStorage.getItem('promo-'+id+'-count'), 10);

	// If no number found, assume first time and show promo
	if (isNaN(lsPromoCount)) {
		updateLocalStorage(id, 0);
		return true;
	}

	// If count is max safe, do not show
	if (lsPromoCount === Number.MAX_SAFE_INTEGER) return false;

	// If no count and buffer, then always show
	if (!config.showCount && !config.bufferMinutes) return true;

	// If already at count, do not show promo
	if (lsPromoCount >= showCount) return false;

	let lsDateViewed = localStorage.getItem('promo-'+id+'-dateviewed');
	// If no date stored then assume we show it
	if (!lsDateViewed) {
		updateLocalStorage(id, lsPromoCount);
		return true;
	}

	// If date stored plus the buffer is before the current date, show promo
	if (DateTime.fromISO(lsDateViewed).plus({ minutes: bufferMinutes }) < DateTime.now()) {
		updateLocalStorage(id, lsPromoCount);
		return true;
	}

	return false;
}

function updateLocalStorage(id, currentCount) {
	localStorage.setItem('promo-'+id+'-count', currentCount+1);
	localStorage.setItem('promo-'+id+'-dateviewed', DateTime.now().toISO());
}

export function hidePromo(config) {
	if (!config || !config.id) return false;
	updateLocalStorage(config.id, Number.MAX_SAFE_INTEGER - 1);
}
